<div class="fm">
  <div class="fm-record" *ngIf="showRecord">
    <h3 class="fm-sage-name">{{ changing.originalSageName }}</h3>
    <p class="fm-sub">{{ recordLine }}</p>
  </div>

  <div class="fm-section">
    <label class="fm-label" [for]="uid + '-search'">Which Aivor {{ noun }} is the same thing?</label>
    <div class="fm-search">
      <i class="bi bi-search" aria-hidden="true"></i>
      <input
        [id]="uid + '-search'"
        type="search"
        autocomplete="off"
        [placeholder]="'Search Aivor ' + noun + 's'"
        [(ngModel)]="query"
        [disabled]="saving"
      />
    </div>

    <div class="fm-options" role="radiogroup" [attr.aria-label]="'Aivor ' + noun + 's'">
      <button
        type="button"
        class="fm-option"
        role="radio"
        *ngFor="let option of picker.options; trackBy: trackOption"
        [class.on]="!addingNew && targetId === option.row.aivorRecordId"
        [attr.aria-checked]="!addingNew && targetId === option.row.aivorRecordId"
        [disabled]="saving || !!option.disabledReason"
        (click)="pick(option.row)"
      >
        <span class="fm-radio" aria-hidden="true"></span>
        <span class="fm-option-text">
          <b>{{ option.row.name }}</b>
          <small *ngIf="option.row.code">{{ option.row.code }}</small>
          <small class="fm-note" *ngIf="option.disabledReason || option.linkedNote">{{ option.disabledReason || option.linkedNote }}</small>
        </span>
      </button>
      <p class="fm-hint" *ngIf="picker.total > picker.options.length">
        Showing {{ picker.options.length }} of {{ picker.total }}. Search to find the others.
      </p>
      <p class="fm-hint" *ngIf="!picker.total">No Aivor {{ noun }} matches your search.</p>

      <button
        type="button"
        class="fm-option"
        role="radio"
        [class.on]="addingNew"
        [attr.aria-checked]="addingNew"
        [disabled]="saving"
        (click)="pickNew()"
      >
        <span class="fm-radio" aria-hidden="true"></span>
        <span class="fm-option-text">
          <b>No match: add as new in Aivor</b>
          <small>Creates a new {{ noun }} from Sage's record</small>
        </span>
      </button>
    </div>
  </div>

  <div class="fm-section fm-new" *ngIf="addingNew">
    <div class="field" *ngIf="isItem">
      <label [for]="uid + '-code'">Item code</label>
      <input [id]="uid + '-code'" type="text" maxlength="50" autocomplete="off" [(ngModel)]="code" [disabled]="saving" />
    </div>
    <div class="field">
      <label [for]="uid + '-name'">Name</label>
      <input [id]="uid + '-name'" type="text" maxlength="255" autocomplete="off" [(ngModel)]="name" [disabled]="saving" />
    </div>

    <ng-container *ngIf="isItem">
      <div class="field">
        <label [id]="uid + '-type'">Item type</label>
        <div class="fm-fixed" *ngIf="isService; else typePicker">Service</div>
        <ng-template #typePicker>
          <div class="segmented-control" role="group" [attr.aria-labelledby]="uid + '-type'">
            <button
              type="button"
              class="segmented-option"
              *ngFor="let t of itemTypes"
              [class.active]="itemTypeId === t.id"
              [attr.aria-pressed]="itemTypeId === t.id"
              [disabled]="saving"
              (click)="itemTypeId = t.id"
            >
              {{ t.label }}
            </button>
          </div>
        </ng-template>
      </div>

      <div class="field">
        <label [for]="uid + '-unit'">Unit in Aivor</label>
        <select [id]="uid + '-unit'" [ngModel]="uomId == null ? '' : '' + uomId" (ngModelChange)="selectUnit($event)" [disabled]="saving">
          <option value="">Same unit as in Sage</option>
          <option *ngFor="let u of units" [value]="'' + u.id">{{ u.name }} ({{ u.code }})</option>
        </select>
      </div>
    </ng-container>
  </div>

  <div class="fm-section fm-swap" *ngIf="showSwap">
    <p>Sage's {{ target?.originalSageName }} is linked to {{ target?.name }} now. Link it to {{ changing.name }} instead?</p>
    <div class="segmented-control" role="group" aria-label="Swap the two links">
      <button type="button" class="segmented-option" [class.active]="swap" [attr.aria-pressed]="swap" [disabled]="saving" (click)="swap = true">
        Yes, swap them
      </button>
      <button type="button" class="segmented-option" [class.active]="!swap" [attr.aria-pressed]="!swap" [disabled]="saving" (click)="swap = false">
        No
      </button>
    </div>
  </div>

  <div class="fm-preview" *ngIf="lines.length">
    <b>What will change</b>
    <ul>
      <li *ngFor="let line of lines"><i class="bi bi-check2" aria-hidden="true"></i><span>{{ line }}</span></li>
    </ul>
  </div>

  <div class="fm-footer">
    <div class="fm-error" role="alert" *ngIf="error">{{ error }}</div>
    <div class="fm-actions">
      <button type="button" class="btn-secondary" [disabled]="saving" (click)="cancel.emit()">Cancel</button>
      <button type="button" class="btn-teal-gradient" [disabled]="!canSave" (click)="save()">{{ saveLabel }}</button>
    </div>
  </div>
</div>
